import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { PasswordValidationCallbacks, singleEmailValidation } from "@/services/misc/functions/ValidationFunctions";

export default class InstallWPForm {
  public title: string = '';

  public user: string = '';

  public password: string = '';

  public email: string = '';

  public directory: string = '';

  public forceInstall: boolean = false;

  public databaseId?: number;

  public enableRedisCache: boolean = false;

  public selectedPlugins: string[] = [];

  public rules: { [name: string]: FormValidationFunction[] } = {
    title: [
      (v: string) => !!v || 'Title is required!',
      (v: string) => v.length >= 3 || 'Title has to be at least 3 characters',
    ],
    user: [
      (v: string) => !!v || 'WP User is required',
      (v: string) => v.length <= 24 || 'WP User can be at most 24 characters',
      (v: string) => v.length >= 3 || 'WP User has to be at least 3 characters',
      (v: string) => !v || /^[a-zA-Z0-9]+$/.test(v) || 'WP User must contain only letters and numbers',
    ],
    password: [
      (v: string) => !!v || 'Password is required',
      ...PasswordValidationCallbacks
    ],
    email: [
      ...singleEmailValidation(),
    ],
    databaseId: [
      (v: number) => !!v || 'Database is required',
      (v: number) => v >= 0 || 'Database must be equal or more than 0',
    ],
    directory: [
      (v: string) => !!v || 'Directory is required!',
    ]
  };
}
